import React, { useEffect, useRef, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import FollowUs from './FollowUs';
import { Link } from 'react-router-dom';
import Newsletter from './Newsletter';
import MenuGroup from './MenuGroup';
import GetTheApp from './GettheApp';
import FooterLogo from '../../assets/images/svg/footerLogo.svg';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const footerMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const checkIfInView = () => {
      if (!footerMenuRef.current) return;
      const rect = footerMenuRef.current.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom >= 0;
      if (inView) {
        setIsVisible(true);
      }
    };

    requestAnimationFrame(() => {
      setTimeout(() => {
        checkIfInView();
      }, 100);
    });

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 },
    );

    if (footerMenuRef.current) {
      observer.observe(footerMenuRef.current);
    }

    return () => {
      if (footerMenuRef.current) {
        observer.unobserve(footerMenuRef.current);
      }
    };
  }, []);

  return (
    <footer className="text-white">
      <div className="footer-container">
        <Container>
          <Row>
            <Col md={5} sm={12}>
              <div className="footer-title-section" data-aos="fade-up">
                <img src={FooterLogo} alt="footer-logo" />
                <p className="head-gap-lg">
                  Legalligence delivers efficient legal solutions through expert insight and smart
                  technology—trusted across firms, businesses, and individuals.
                </p>
              </div>
            </Col>

            <Col md={4} sm={12}>
              <MenuGroup />
            </Col>
            <Col md={3} sm={12}>
              <GetTheApp />
            </Col>
          </Row>

          <hr className="border-white footer-hr" />

          <div
            className={`footer-copyrights-section ${isVisible ? 'fade-up' : 'fade-reset'}`}
            ref={footerMenuRef}
          >
            <Row className="mt-3 align-items-center copyrights-row">
              <Col md={4} sm={12} className="text-white-50 small">
                <FollowUs />
              </Col>
              <Col md={4} sm={12} className="copyrights-order-3">
                <p className="copy-rights text-center">
                  {' '}
                  © {new Date().getFullYear()} Legalligence. All Rights Reserved
                </p>
              </Col>
              <Col md={4} sm={12} className="text-lg-end text-white-50 small text-sm-center">
                <Link to="privacy-policy" className="me-2 privacy-policy">
                  Privacy policy
                </Link>{' '}
                <Link to="terms-of-use" className="ms-2 terms-of-use">
                  Terms of use
                </Link>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
